const NUMBER_OF_REVIEWS = 200;
const STORE_FRONT_API_URL =
  "https://halm-club.myshopify.com/api/2025-01/graphql.json";
const AUTH_TOKEN = "2af74335d38288a0dfa378f89c76f8c1";

async function fetchImages(ids) {
  const imageQuery = `
  {
    nodes(ids: ${JSON.stringify(ids)}) {
        ... on MediaImage {
          id
          image {
            url
          }
        }
       }
  }
  `;

  try {
    const response = await fetch(STORE_FRONT_API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": AUTH_TOKEN,
      },
      body: JSON.stringify({ query: imageQuery }),
    });
    const decoded = await response.json();
    return decoded.data.nodes;
  } catch (error) {
    console.error(error);
  }
}

const query = `
{
   metaobjects(type: "review", first: ${NUMBER_OF_REVIEWS}, sortKey: "updated_at") {
      nodes {
        fields {
          key
          value
        }
        updatedAt
      }
   }
}`;

const fetchReviewsFromStorefront = async () => {
  try {
    const response = await window.fetchWithRetry(STORE_FRONT_API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": AUTH_TOKEN,
      },
      body: JSON.stringify({ query }),
    });
    const { data } = response;
    return data.metaobjects.nodes;
  } catch (error) {
    console.error(error);
    throw new Error("Failed to fetch customer reviews");
  }
};

const mapResponseToReview = async (response) => {
  const responseWithImageReferences = response.map((review) => {
    const fields = review.fields.reduce((acc, field) => {
      let value = field.value;

      // Check if the field is a JSON string (e.g., array or object)
      try {
        const parsed = JSON.parse(value);
        if (Array.isArray(parsed) || typeof parsed === "object") {
          value = parsed; // Replace with parsed array/object if valid JSON
        }
      } catch {
        // Not JSON; keep original value
      }

      return { ...acc, [field.key]: value };
    }, {});
    return {
      ...fields,
      updatedAt: review.updatedAt,
    };
  });
  const imageReferences = responseWithImageReferences
    .filter((review) => !!review.image)
    .flatMap((review) => review.image);
  const images = await fetchImages(imageReferences);
  return responseWithImageReferences.map((review) => {
    if (review.image) {
      const correspondingImage = images.find(
        (image) => review.image === image.id,
      );
      return {
        ...review,
        image: correspondingImage?.image?.url,
      };
    }
    return review;
  });
};

async function fetchReviews() {
  const reviews = await fetchReviewsFromStorefront();
  return await mapResponseToReview(reviews);
}

const ReviewsFetcher = (() => {
  let reviewsPromise = null;

  return {
    getReviews() {
      if (reviewsPromise) {
        return reviewsPromise;
      }
      reviewsPromise = fetchReviews();
      return reviewsPromise;
    },
  };
})();

window.ReviewsFetcher = ReviewsFetcher;
